const p = {
  class: {
    canCreateNew: false,
    canEditExisting: false,
  },
  course: {
    canCreateNew: false,
    canEditCourseInfo: false,
    actOnDotsbuttonTile: true,
  },
  chapter: {
    canCreateNew: true,
    canEditInfo: true,
    canSortChapter: true,
    canArchiveChapter: true,
    canDeleteChapter: true,
    canHideChapter: true,
    canCloneChapter: true,
    canDuplicateChapter: true,
    canBulkAssign: true,
    bulkAssignOptions: [
      {
        value: 'review',
        label: 'Submit for SE Correction',
      },
      {
        value: 'qc_review',
        label: 'Submitted for QC review',
        // isDisabled: true,
      },
      {
        value: 'teacher_review',
        label: 'Submit for Tutor Vetting',
      },
    ],
  },
  mindmap: {
    dropDownOptions: [
      {
        value: 'review',
        label: 'Submit for SE Correction',
      },
      // {
      //   value: 'qc_review',
      //   label: 'Submit back to QC review',
      // },
      {
        value: 'teacher_review',
        label: "Submitted for Teacher's review",
      },
      // {
      //   value: 'teacher_verified',
      //   label: 'Mark as verified',
      // },
    ],
  },
  lesson: {
    canAddLesson: true,
    canEditLesson: true,
    canSortLesson: true,
    canArchiveLesson: true,
    canHideLesson: true,
    canCloneLesson: true,
    canDuplicateLesson: true,
  },
  subLesson: {
    canAddSubLesson: true,
    canEditSubLesson: true,
    canSortSubLesson: true,
    canArchiveSubLesson: true,
    canHideSubLesson: true,
    canCloneSubLesson: true,
    canDuplicateSubLesson: true,
  },
  topic: {
    notes: {
      canPublish: false,
      showDraft: true,
      canAddComments: true,
      canViewComments: true,
      reviewOptions: [
        // {
        //   value: 'draft',
        //   label: 'Draft',
        // },
        {
          value: 'review',
          label: 'Submit for SE Correction',
          isDisabled: true,
        },
        {
          value: 'qc_review',
          label: 'Submit for QC Review',
        },
        {
          value: 'teacher_review',
          label: 'Submit for Tutor Vetting',
          // isDisabled: true,
        },
      ],
    },
    geekCorner: {
      canPublish: false,
      showDraft: true,
      canAddComments: true,
      canViewComments: true,
      reviewOptions: [
        // {
        //   value: 'inactive',
        //   label: 'Inactive',
        // },
        // {
        //   value: 'draft',
        //   label: 'Draft',
        // },
        {
          value: 'review',
          label: 'Submit for SE Correction',
          isDisabled: true,
        },
        {
          value: 'qc_review',
          label: 'Submit for QC Review',
        },
        {
          value: 'teacher_review',
          label: 'Submit for Tutor Vetting',
          // isDisabled: true,
        },
      ],
    },
  },
  perform: {
    quiz: {
      reviewOptions: [
        // {
        //   value: 'draft',
        //   label: 'Draft',
        // },
        {
          value: 'review',
          label: 'Submit for SE Correction',
          isDisabled: true,
        },
        {
          value: 'qc_review',
          label: 'Submitted for QC review',
        },
        {
          value: 'teacher_review',
          label: 'Submit for Tutor Vetting',
        },
      ],
    },
  },
  assess: {
    quiz: {
      reviewOptions: [
        // {
        //   value: 'draft',
        //   label: 'Draft',
        // },
        {
          value: 'review',
          label: 'Submit for SE Correction',
          isDisabled: true,
        },
        {
          value: 'qc_review',
          label: 'Submitted for QC review',
        },
        {
          value: 'teacher_review',
          label: 'Submit for Tutor Vetting',
        },
      ],
    },
  },
};

export default p;
